export enum ApiStatusConstants {
  INITIAL,
  SUCCESS,
  LOADING,
  FAILURE,
}

export enum AdminRole {
  GLOBAL_ADMIN = 'global-admin',
  SUB_ADMIN = 'sub-admin',
}

export enum UserType {
  BABYSITTER = 'babysitter',
  CONSUMER = 'consumer',
}

export enum TermsType {
  PARTICIPANT = 'Participant',
  SUPERVISOR = 'Supervisor',
}
